<template>
  <div class="header w-default">
    <div class="d-flex ai-center jc-between w-100">
      <img class="logo" src="../assets/img/logo.png" />
      <div class="nav d-flex h-100 ai-center">
        <div :class="['nav-item',{'active':$route.meta.id===0}]" @click="$router.push('/')">首页</div>
        <div
          :class="['nav-item',{'active':$route.meta.id===1}]"
          @click="$router.push('/Product')"
        >产品</div>
        <div
          :class="['nav-item',{'active':$route.meta.id===2}]"
          @mouseover="show()"
          @mouseout="hide()"
        >方案</div>
        <div :class="['nav-item',{'active':$route.meta.id===3}]" @click="$router.push('/Case')">案例</div>
        <div :class="['nav-item',{'active':$route.meta.id===4}]" @click="$router.push('/News')">公司动态</div>
        <div
          :class="['nav-item',{'active':$route.meta.id===5}]"
          @click="$router.push('/About')"
        >关于我们</div>
        <!-- <div :class="['nav-item',{'active':$route.meta.id===6}]" @click="$router.push('/Talents')">人才招聘</div> -->
      </div>
      <div class="right">
        <div>联系我们</div>
        <div>人才招聘</div>
      </div>
    </div>
    <div class="item-2 w-default ai-center" v-show="isShow" @mouseover="show()" @mouseout="hide()">
      <div class="name fs-xl">方案</div>
      <div class="center">
        <h2 class="text-primary">解决方案</h2>
        <ul>
          <li @click="$router.push('/SolutionMuseum')">智慧文博解决方案</li>
          <li @click="$router.push('/SolutionEducation')">智慧校园解决方案</li>
          <li @click="$router.push('/SolutionInstrumentatio')">智慧物联解决方案</li>
          <li @click="$router.push('/SolutionSecurityAndProtection')">智慧安防解决方案</li>
        </ul>
      </div>
      <img src="../assets/img/eg/1.jpg" alt />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    path(path) {
      if (path === "/") {
        this.isActive = 0;
      }
    }
  },
  watch: {
    /* 监听路由变化 */
    $route(to, from) {
      console.log(to.path);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
.header {
  .logo {
    height: 24px;
    margin-right: 60px;
  }
  .nav {
    flex: 1;
    .nav-item {
      display: flex;
      align-items: center;
      border-bottom: 3px solid transparent;
      margin: 0 20px;
      height: 68px;
      padding: 0 20px;
      justify-content: center;
      cursor: pointer;
      &.active,
      &:hover {
        border-color: map-get($colors, "primary");
        color: map-get($colors, "primary");
      }
    }
  }
  .right {
    display: flex;
    div {
      color: #999999;
      font-size: 14px;
      padding: 0 14px;
      border-right: 1px solid #999999;
      cursor: pointer;
      &:hover {
        color: map-get($colors, "primary");
      }
      &:last-child{
        border: none;
      }
    }
  }
  .item-2 {
    position: absolute;
    z-index: 9999;
    background-color: #fafafa;
    padding: 20px 80px 20px 0;
    display: flex;
    .name {
      line-height: 280px;
      width: 220px;
      text-align: center;
      border-right: 1px solid #cccccc;
    }
    .center {
      flex: 1;
      padding: 0 60px;
      h2 {
        font-weight: bold;
        margin-bottom: 26px;
      }
      ul {
        li {
          margin-bottom: 26px;
          cursor: pointer;
          &:hover {
            color: map-get($colors, "primary");
          }
        }
      }
    }
    > img {
      height: 200px;
      width: 330px;
      object-fit: cover;
    }
  }
}
</style>